import { Typography } from 'components/_common/Typography';
import { RiskLikelihood } from 'models/RiskCategories';
import React from 'react';

type NoChanceOfCasesSummaryProps = {
  locationName: string;
  parentLocationName: string;
  parentLocationReportedCases: number;
  reportedCases: number;
  importationRiskLikelihood: RiskLikelihood;
};

const NoChanceOfCasesSummary: React.FC<NoChanceOfCasesSummaryProps> = ({
  locationName,
  parentLocationName,
  parentLocationReportedCases,
  reportedCases,
  importationRiskLikelihood,
}) => {
  const noParentLocationReportedCases = parentLocationReportedCases <= 0 && reportedCases <= 0;
  if (noParentLocationReportedCases && importationRiskLikelihood === 'Unlikely') {
    return (
      <div data-testid="no-chance-summary">
        <Typography variant="subtitle1" inline>
          No reported cases
        </Typography>{' '}
        in {parentLocationName} and it is
        <Typography variant="subtitle1" inline>
          {' '}
          unlikely that a case will arrive
        </Typography>{' '}
        to {locationName} in the next month
      </div>
    );
  }
  if (
    parentLocationReportedCases <= 0 &&
    reportedCases <= 0 &&
    (importationRiskLikelihood === 'Not calculated' ||
      importationRiskLikelihood === 'Calculating, revisit later!')
  ) {
    return (
      <div data-testid="no-chance-summary">
        <Typography variant="subtitle1" inline>
          No reported cases
        </Typography>{' '}
        in {parentLocationName}
      </div>
    );
  }
  return null;
};

export default NoChanceOfCasesSummary;
